import { x } from './index-BvoALBv3.js';

const store_icon = x`<svg viewBox="0 0 24 24" fill="none">
  <path d="M19 11V19H5V11" stroke="currentColor" stroke-width="2" />
  <path
    d="M4 10V11H20V10L18 7V5C18 4.44772 17.5523 4 17 4H7C6.44772 4 6 4.44772 6 5V7L4 10Z"
    stroke="currentColor"
    stroke-width="2"
  />
</svg> `;

const cross_icon = x`<svg viewBox="0 0 24 24" fill="none">
  <path
    d="M12.0001 10.8687L6.90884 5.7774L5.49463 7.19162L10.5859 12.2829L5.77757 17.0913L7.19179 18.5055L12.0001 13.6971L16.8083 18.5053L18.2226 17.0911L13.4144 12.2829L18.5055 7.19179L17.0913 5.77758L12.0001 10.8687Z"
    fill="currentColor"
  />
</svg> `;

const location_icon = x`<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8 14.5C8.2 14.5 8.35546 14.394 8.415 14.3521C8.50046 14.2919 8.58616 14.2151 8.66777 14.1341C8.83298 13.97 9.02565 13.7441 9.23158 13.4776C9.64553 12.9419 10.1422 12.2041 10.6206 11.3749C11.099 10.5456 11.5652 9.61447 11.9131 8.69209C12.2586 7.77626 12.5 6.83645 12.5 6C12.5 3.51472 10.4853 1.5 8 1.5C5.51472 1.5 3.5 3.51472 3.5 6C3.5 6.83645 3.74142 7.77626 4.08686 8.69209C4.43478 9.61447 4.90101 10.5456 5.37941 11.3749C5.85781 12.2041 6.35447 12.9419 6.76842 13.4776C6.97434 13.7441 7.16702 13.97 7.33223 14.1341C7.41384 14.2151 7.49954 14.2919 7.585 14.3521C7.64454 14.394 7.8 14.5 8 14.5ZM9.5 6C9.5 6.82843 8.82843 7.5 8 7.5C7.17157 7.5 6.5 6.82843 6.5 6C6.5 5.17157 7.17157 4.5 8 4.5C8.82843 4.5 9.5 5.17157 9.5 6Z"
    stroke="currentColor"
  />
</svg> `;

const clock_icon = x`<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M7.5 3.5V8.5H10.5V7.5H8.5V3.5H7.5Z" fill="currentColor" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
    fill="currentColor"
  />
</svg> `;

const mail_icon = x`
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.0001 3V4.48973C0.999967 4.49629 0.999968 4.50285 1.0001 4.5094V13H15.0001V4.50944C15.0002 4.50286 15.0002 4.49628 15.0001 4.48969V3H1.0001ZM14.0001 4.20135V4H2.0001V4.20135L8.0001 7.43212L14.0001 4.20135ZM2.0001 5.33711V12H14.0001V5.33711L8.23715 8.44024C8.08916 8.51992 7.91104 8.51992 7.76305 8.44024L2.0001 5.33711Z"
      fill="currentColor"
    />
  </svg>
`;

const phone_icon = x`<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path
    d="M9.18867 9.00645L9.16876 9.02636L9.15121 9.04838L8.71042 9.60147C7.79362 9.07888 6.94934 8.25703 6.4112 7.3212L6.973 6.84295L6.99173 6.827L7.00881 6.80929C7.26023 6.54856 7.3344 6.18304 7.23255 5.85898L7.23262 5.85895L7.2299 5.85078C7.08314 5.41051 7.00667 4.93517 7.00667 4.44C7.00667 3.92386 6.58281 3.5 6.06667 3.5H4.52889C4.34737 3.5 4.10743 3.53837 3.89657 3.67932C3.65935 3.8379 3.5 4.10186 3.5 4.44C3.5 8.84522 7.1596 12.5 11.56 12.5C11.8904 12.5 12.1491 12.3425 12.3076 12.1166C12.4518 11.9112 12.5 11.6718 12.5 11.4756V9.94222C12.5 9.42608 12.0761 9.00222 11.56 9.00222C11.0688 9.00222 10.5929 8.92253 10.1485 8.77874C9.81069 8.66495 9.44029 8.75483 9.18867 9.00645Z"
    stroke="currentColor"
  />
</svg> `;

const search_icon = x`
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="11" cy="11" r="6" stroke="currentColor" stroke-width="2" />
    <path d="M15 15L19 19" stroke="currentColor" stroke-width="2" />
  </svg>
`;
const back_icon = x`
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M10.125 8.18182L13.875 12M13.875 12L17.625 15.8182M13.875 12L10.125 15.8182M13.875 12L17.625 8.18182M6.375 5H22V19H6.375L2 12L6.375 5Z"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
`;
const chevron_down_icon = x`
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17.5 10.5L12.5882 14.0722C12.2375 14.3273 11.7625 14.3273 11.4118 14.0722L6.5 10.5"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
`;
const chevron_left_icon = x`
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M13.5 17.5L9.92776 12.5882C9.67274 12.2375 9.67274 11.7625 9.92776 11.4118L13.5 6.5"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
`;

export { back_icon, chevron_down_icon, chevron_left_icon, clock_icon, cross_icon, location_icon, mail_icon, phone_icon, search_icon, store_icon };
